var _style, _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect4, _rect5, _rect6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect7, _rect8, _rect9, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.98 39.31",
    style: {
      enableBackground: "new 0 0 67.98 39.31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBD20B;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n\t.st9{fill:url(#SVGID_9_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.68,9.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.37,9.68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.52,11.26"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.98,
    y: 22,
    className: "st0",
    width: 4.47,
    height: 3.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.45,
    y: 13.59,
    className: "st0",
    width: 4.3,
    height: 5.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.31,
    y: 9.68,
    className: "st0",
    width: 4.51,
    height: 3.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.7293,
    y1: 23.96,
    x2: 12.3121,
    y2: 23.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 4.186822e-9,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.258656e-7,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3048,
    style: {
      stopColor: "#F6CE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4236,
    style: {
      stopColor: "#E9C41B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#D7B525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#BEA12E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6416,
    style: {
      stopColor: "#A18932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#806E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    style: {
      stopColor: "#5E522F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    style: {
      stopColor: "#3C3727"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8319,
    style: {
      stopColor: "#191917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8369,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCC115"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED683C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.73,22h5.72v0c0,2.17-1.76,3.92-3.92,3.92h-1.8V22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6003,
    y1: 25.6142,
    x2: 13.6003,
    y2: 13.2847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    style: {
      stopColor: "#F6CE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    style: {
      stopColor: "#EAC41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6069,
    style: {
      stopColor: "#D8B525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    style: {
      stopColor: "#BFA22D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#A38A32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8107,
    style: {
      stopColor: "#826F33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    style: {
      stopColor: "#605430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    style: {
      stopColor: "#3F3928"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9571,
    style: {
      stopColor: "#1D1C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9665,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9747,
    style: {
      stopColor: "#161615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9776,
    style: {
      stopColor: "#1C1B19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    style: {
      stopColor: "#26241E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9814,
    style: {
      stopColor: "#343024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#363124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9861,
    style: {
      stopColor: "#4C473C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#8E8A86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#877333"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.45,25.92L11.45,25.92c2.37,0,4.3-1.93,4.3-4.3v-3.73c0-2.37-1.93-4.3-4.3-4.3h0V25.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.3058,
    y1: 11.6373,
    x2: 15.7503,
    y2: 11.6373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E98E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C88853"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A77C58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B7058"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#746354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F544C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4B4541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#070708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#211F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0566,
    style: {
      stopColor: "#4A422B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1028,
    style: {
      stopColor: "#736432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1491,
    style: {
      stopColor: "#9C8533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    style: {
      stopColor: "#C0A32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2421,
    style: {
      stopColor: "#DCBA23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#EEC917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3366,
    style: {
      stopColor: "#F7D011"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7D011"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8D20E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9D30C"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.75,13.59H7.31v0c0-2.16,1.75-3.91,3.91-3.91h0.62C14,9.68,15.75,11.43,15.75,13.59L15.75,13.59z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,37.05L3,37.05l0-23.07c0-2.38,1.93-4.3,4.3-4.3h0v23.07C7.31,35.12,5.38,37.05,3,37.05z"
  }))), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.44,3.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.29,3.17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.76,5.13"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.29,
    y: 18.42,
    className: "st0",
    width: 5.54,
    height: 4.85
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.82,
    y: 8.01,
    className: "st0",
    width: 5.32,
    height: 6.32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.69,
    y: 3.17,
    className: "st0",
    width: 5.58,
    height: 4.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7415,
    y1: 20.8464,
    x2: 37.8901,
    y2: 20.8464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 4.186822e-9,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.258656e-7,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3048,
    style: {
      stopColor: "#F6CE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4236,
    style: {
      stopColor: "#E9C41B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#D7B525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#BEA12E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6416,
    style: {
      stopColor: "#A18932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#806E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    style: {
      stopColor: "#5E522F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    style: {
      stopColor: "#3C3727"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8319,
    style: {
      stopColor: "#191917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8369,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCC115"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED683C"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.74,18.42h7.08v0c0,2.68-2.17,4.86-4.86,4.86h-2.22V18.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.4846,
    y1: 22.894,
    x2: 39.4846,
    y2: 7.6319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    style: {
      stopColor: "#F6CE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    style: {
      stopColor: "#EAC41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6069,
    style: {
      stopColor: "#D8B525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    style: {
      stopColor: "#BFA22D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#A38A32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8107,
    style: {
      stopColor: "#826F33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    style: {
      stopColor: "#605430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    style: {
      stopColor: "#3F3928"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9571,
    style: {
      stopColor: "#1D1C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9665,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9747,
    style: {
      stopColor: "#161615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9776,
    style: {
      stopColor: "#1C1B19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    style: {
      stopColor: "#26241E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9814,
    style: {
      stopColor: "#343024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#363124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9861,
    style: {
      stopColor: "#4C473C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#8E8A86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#877333"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.82,23.28L36.82,23.28c2.94,0,5.32-2.38,5.32-5.32v-4.62c0-2.94-2.38-5.32-5.32-5.32h0V23.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.693,
    y1: 5.5927,
    x2: 42.1461,
    y2: 5.5927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E98E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C88853"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A77C58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B7058"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#746354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F544C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4B4541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#070708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#211F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0566,
    style: {
      stopColor: "#4A422B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1028,
    style: {
      stopColor: "#736432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1491,
    style: {
      stopColor: "#9C8533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    style: {
      stopColor: "#C0A32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2421,
    style: {
      stopColor: "#DCBA23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#EEC917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3366,
    style: {
      stopColor: "#F7D011"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7D011"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8D20E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9D30C"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M42.15,8.01H31.69v0c0-2.67,2.17-4.84,4.84-4.84h0.77C39.98,3.17,42.15,5.34,42.15,8.01L42.15,8.01z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.37,37.05L26.37,37.05l0-28.55c0-2.94,2.38-5.32,5.32-5.32h0v28.55C31.69,34.67,29.31,37.05,26.37,37.05z"
  }))), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.8,9.68"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.49,9.68"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.64,11.26"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 22,
    className: "st0",
    width: 4.47,
    height: 3.92
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.57,
    y: 13.59,
    className: "st0",
    width: 4.3,
    height: 5.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 55.42,
    y: 9.68,
    className: "st0",
    width: 4.51,
    height: 3.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8481,
    y1: 23.96,
    x2: 60.431,
    y2: 23.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 4.186822e-9,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.258656e-7,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3048,
    style: {
      stopColor: "#F6CE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4236,
    style: {
      stopColor: "#E9C41B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#D7B525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#BEA12E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6416,
    style: {
      stopColor: "#A18932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#806E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    style: {
      stopColor: "#5E522F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    style: {
      stopColor: "#3C3727"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8319,
    style: {
      stopColor: "#191917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8369,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCC115"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED683C"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.85,22h5.72v0c0,2.17-1.76,3.92-3.92,3.92h-1.8V22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.7191,
    y1: 25.6142,
    x2: 61.7191,
    y2: 13.2847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3753,
    style: {
      stopColor: "#F6CE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    style: {
      stopColor: "#EAC41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6069,
    style: {
      stopColor: "#D8B525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    style: {
      stopColor: "#BFA22D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#A38A32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8107,
    style: {
      stopColor: "#826F33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    style: {
      stopColor: "#605430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    style: {
      stopColor: "#3F3928"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9571,
    style: {
      stopColor: "#1D1C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9665,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9747,
    style: {
      stopColor: "#161615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9776,
    style: {
      stopColor: "#1C1B19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    style: {
      stopColor: "#26241E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9814,
    style: {
      stopColor: "#343024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#363124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9861,
    style: {
      stopColor: "#4C473C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#8E8A86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#877333"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.57,25.92L59.57,25.92c2.37,0,4.3-1.93,4.3-4.3v-3.73c0-2.37-1.93-4.3-4.3-4.3h0V25.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.4246,
    y1: 11.6373,
    x2: 63.8692,
    y2: 11.6373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E98E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C88853"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A77C58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B7058"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#746354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F544C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4B4541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E1D1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#070708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#211F1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0566,
    style: {
      stopColor: "#4A422B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1028,
    style: {
      stopColor: "#736432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1491,
    style: {
      stopColor: "#9C8533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    style: {
      stopColor: "#C0A32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2421,
    style: {
      stopColor: "#DCBA23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#EEC917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3366,
    style: {
      stopColor: "#F7D011"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7D011"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8D20E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9D30C"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M63.87,13.59h-8.44v0c0-2.16,1.75-3.91,3.91-3.91h0.62C62.12,9.68,63.87,11.43,63.87,13.59L63.87,13.59z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.12,37.05L51.12,37.05l0-23.07c0-2.38,1.93-4.3,4.3-4.3h0v23.07C55.42,35.12,53.5,37.05,51.12,37.05z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da82416a25697ffe6134e6124469780e.svg";
export { ForwardRef as ReactComponent };